/**
 * Single source of truth for the email-campaign feature's route base.
 *
 * The feature physically lives under `src/crm/` (the walled CRM sub-app)
 * but is surfaced in the Marketing section at `/marketing/campaigns` — it
 * was cut out of `/crm` on 2026-06-02 and moved next to the autonomous
 * marketing agent. Internal navigation MUST go through this helper so
 * there is exactly one place to repoint if the mount ever moves again.
 */
export const EMAIL_CAMPAIGNS_BASE = "/marketing/campaigns";

export function emailCampaignsPath(sub = ""): string {
  return `${EMAIL_CAMPAIGNS_BASE}${sub}`;
}

/**
 * Deep-link to a single campaign's editor.
 *
 * Falls back to the list when the id is missing so a malformed legacy
 * `/crm` bookmark can never build a `.../edit/undefined` URL.
 */
export function emailCampaignEditPath(id: string | number | undefined | null): string {
  return id === undefined || id === null || id === "" ? emailCampaignsPath() : emailCampaignsPath(`/edit/${id}`);
}

/**
 * Deep-link to a single campaign's Sendout Logs (per-recipient delivery
 * state). Note the shape: the id comes FIRST (`:id/logs`), unlike the
 * editor's `edit/:id`. Same missing-id fallback as above.
 */
export function emailCampaignLogsPath(id: string | number | undefined | null): string {
  return id === undefined || id === null || id === "" ? emailCampaignsPath() : emailCampaignsPath(`/${id}/logs`);
}
